module.exports = __webpack_public_path__ + "img/mobile_self_new.d0f2699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterAd/image/mobile_self_new.jpg
// module id = 6QH6
// module chunks = 0